@if (isLoading) {
<app-loading-spinner text="New Lot"></app-loading-spinner>
} @if (!isLoading) {
<div
  class="py-2 px-4 page-height overflow-auto flex flex-col"
  (scroll)="onBidsAndOffersScroll($event)"
>
  <div class="flex-1">
    <div class="flex justify-between items-end mb-4 mx-auto max-w-xl">
      <div class="font-medium text-xl">New {{ lotType }}</div>
      <button
        type="button"
        (click)="Cancel()"
        class="text-custom-orange text-lg"
      >
        Cancel
      </button>
    </div>
    <form [formGroup]="newLotForm" (ngSubmit)="onSubmit()">
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Contract Info</div>
      </div>
      <mat-card
        appearance="outlined"
        class="my-card rounded-md tablet-max:rounded-lg py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col gap-1"
      >
        <app-autocomplete
          label="Term"
          appearance="outline"
          [autocompleteControl]="newLotForm.get('timeFrameControl')"
          [required]="true"
          [options]="timeFrames$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>

        <div class="text-sm">
          @switch (newLotForm.get('timeFrameControl').value) { @case('Day'){ Day
          bids/offers will remain active until the market closes at 5 PM MDT if
          created prior to the closing hours, or until the subsequent day's
          market closure if created thereafter } @case('Week'){ Week lots will
          remain active for 7 Calendar days until 5 PM MDT } @case('GTC'){ GTC
          (Good Until Canceled) lots will persist until manually withdrawn by
          the user } @default { } }
        </div>
      </mat-card>
      @if(marketType() === 'Export' || marketType() === 'Track'){
      <mat-card
        appearance="outlined"
        class="py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col gap-1"
      >
        <div
          class="flex flex-row items-center justify-between mx-auto max-w-xl pl-2.5 mb-2 w-full"
        >
          <span>Indication</span>
          <mat-checkbox
            color="primary"
            [formControl]="newLotForm.get('indicationControl')"
            labelPosition="before"
          >
          </mat-checkbox>
        </div>
        <span class="text-xs">
          A Bid/Offer indication represents a non-binding expression of interest
          from a buyer (bid) or seller (offer) to transact at a specific price
          or within a price range. It is used to gauge market sentiment and
          initiate potential negotiations, without guaranteeing execution.
        </span>
      </mat-card>
      }
      <div
        class="flex items-center justify-between mx-auto max-w-xl px-2.5 mb-2"
      >
        <div class="text-md dark:text-gray-300">Product Info</div>
        <mat-chip-set class="text-xs flex flex-row pl-2 items-start">
          <mat-chip-option
            style="margin-left: 4px !important"
            disableRipple="true"
            [ngClass]="{
              'blue-chip': lotType === 'Offer',
              'green-chip': lotType === 'Bid'
            }"
          >
            {{ lotType }}
          </mat-chip-option>
        </mat-chip-set>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
      >
        <app-autocomplete
          label="Origin Country"
          appearance="outline"
          [autocompleteControl]="newLotForm.get('originControl')"
          [required]="true"
          [options]="origins$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <app-autocomplete
          label="Commodity"
          [autocompleteControl]="newLotForm.get('cropTypeControl')"
          [required]="true"
          [options]="commodities"
          [optGroup]="{
            title: favouriteCommodities().length > 0 ? 'Favourites' : null,
            list: favouriteCommodities()
          }"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        @if ( showProductTypeControl && newLotForm.get('productTypeControl') !==
        '' ) {
        <app-autocomplete
          label="Product Type"
          [autocompleteControl]="newLotForm.get('productTypeControl')"
          [required]="false"
          [options]="productTypes$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        } @if (showGradeControl) {
        <app-autocomplete
          label="Grade"
          [autocompleteControl]="newLotForm.get('gradeControl')"
          [required]="true"
          [options]="grades$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        }
      </mat-card>
      @if (specifications$ | async; as specs) { @if (specs.length) {
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Specifications</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
        formArrayName="specificationsControl"
      >
        @for ( spec of newLotForm.get('specificationsControl').controls; track
        spec.get('title').value; let i = $index) {
        <div class="-full" [formGroupName]="i">
          <mat-form-field class="x-full" style="width: 100%">
            <mat-label>{{ spec.get("title").value }}</mat-label>
            <input matInput type="text" formControlName="value" />
          </mat-form-field>
        </div>
        }
      </mat-card>
      } }
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Delivery</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
      >
        <app-autocomplete
          label="Delivery Type"
          [autocompleteControl]="newLotForm.get('deliveryTypeControl')"
          [required]="true"
          [options]="deliveryTypeOptions$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <app-autocomplete
          label="Delivery Option"
          [autocompleteControl]="newLotForm.get('deliveryOptionControl')"
          [required]="true"
          [options]="deliveryOptions$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <app-autocomplete
          label="Container Type"
          [autocompleteControl]="newLotForm.get('containerTypeControl')"
          [required]="true"
          [options]="containerTypes$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <div class="flex flex-row justify-between items-start gap-3">
          <app-autocomplete
            class="w-full"
            label="Location"
            [autocompleteControl]="newLotForm.get('destinationControl')"
            [required]="true"
            [options]="destinations$ | async"
            [optGroup]="{
              title: recentlySearchedLocations().length
                ? 'Recently Searched'
                : null,
              list: recentlySearchedLocations()
            }"
            [errorStateMatcher]="matcher"
          >
          </app-autocomplete>
          @if (searchingLocation()) {
          <mat-spinner class="mt-3" [diameter]="35"></mat-spinner>
          }
        </div>
        @if ( (newLotForm.get('destinationControl').hasError('required') ||
        newLotForm .get('destinationControl') .hasError('invalidDestination'))
        && (newLotForm.get('destinationControl').touched ||
        newLotForm.get('destinationControl').dirty) ) {
        <mat-error>
          Enter a valid location. city/town, province, country
        </mat-error>
        } @if (tolerances$ | async; as tolerances) { @if (tolerances.length) {
        <app-autocomplete
          label="Tolerance"
          [autocompleteControl]="newLotForm.get('toleranceControl')"
          [required]="false"
          [options]="tolerances"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        } } @if (packagingTypes$ | async; as pkg) { @if (pkg.length) {
        <app-autocomplete
          label="Packaging"
          [autocompleteControl]="newLotForm.get('packagingTypeControl')"
          [required]="false"
          [options]="pkg"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        } }
      </mat-card>
      @if (documentations$ | async; as docs) { @if
      (newLotForm.get('documentationsControl').value && docs.length) {
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Documentations</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
        formArrayName="documentationsControl"
      >
        @for ( doc of newLotForm.get('documentationsControl').controls; track
        doc.get('title').value; let i = $index) {
        <div class="-full" [formGroupName]="i">
          @if(currentDocumentations()[i].type === controlTypes.Text){
          <mat-form-field class="x-full" style="width: 100%">
            <mat-label>{{ doc.get("title").value }}</mat-label>
            <input matInput type="text" formControlName="value" />
          </mat-form-field>
          } @else if(currentDocumentations()[i].type == controlTypes.Select){
          <mat-form-field class="x-full" style="width: 100%">
            <mat-label>{{ doc.get("title").value }}</mat-label>
            <input
              matInput
              type="text"
              [matAutocomplete]="auto"
              formControlName="value"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete #auto="matAutocomplete">
              @for ( option of currentDocumentations()[i].options; track option;
              let j = $index) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          }
        </div>
        }
      </mat-card>
      } }
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Delivery Window</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
      >
        <mat-form-field>
          <mat-label>Choose a date range</mat-label>
          <mat-date-range-input
            [rangePicker]="picker"
            [formGroup]="newLotForm.get('deliveryWindowControl')"
            [min]="minDate"
          >
            <input
              matStartDate
              [formControl]="newLotForm.get('deliveryWindowControl.start')"
              placeholder="Start date"
              [errorStateMatcher]="matcher"
            />
            <input
              matEndDate
              [formControl]="newLotForm.get('deliveryWindowControl.end')"
              placeholder="End date"
              [errorStateMatcher]="matcher"
            />
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker touchUi #picker></mat-date-range-picker>
          @if ( (newLotForm .get('deliveryWindowControl.start')
          .hasError('required') || newLotForm .get('deliveryWindowControl.end')
          .hasError('required')) &&
          (newLotForm.get('deliveryWindowControl').touched ||
          newLotForm.get('deliveryWindowControl').dirty) ) {
          <mat-error> Please enter a date range </mat-error>
          }
        </mat-form-field>
      </mat-card>
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Pricing</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
      >
        @if (priceTypes$ | async; as priceTypes) { @if (priceTypes.length > 1) {
        <mat-form-field>
          <mat-label>Price Type</mat-label>
          <mat-select [formControl]="newLotForm.get('priceTypeControl')">
            @for (type of priceTypes; track type) {
            <mat-option [value]="type">{{ type }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } } @if (currencies$ | async; as currencies) {
        <mat-form-field>
          <mat-label>Currency</mat-label>
          <mat-select [formControl]="newLotForm.get('currencyControl')">
            @for (currency of currencies; track currency.name) {
            <mat-option [value]="currency.name">
              {{ currency.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        <div
          class="w-full items-center justify-between gap-2"
          [ngClass]="
            newLotForm.get('priceTypeControl').value === 'Basis'
              ? 'basis-price'
              : 'cash-price'
          "
        >
          @if (newLotForm.get('priceTypeControl').value === 'Basis') {
          <div
            class="flex flex-col flex-nowrap tablet-max:flex-wrap"
            formGroupName="basisPriceControl"
          >
            <div class="flex flex-row flex-nowrap gap-2 tablet-max:flex-wrap">
              <mat-form-field class="w-2/5 tablet-max:w-full">
                <mat-label>Basis Points</mat-label>
                <input
                  type="number"
                  formControlName="basisPoints"
                  matInput
                  [errorStateMatcher]="groupMatcher"
                />
              </mat-form-field>
              <mat-form-field class="tablet-max:w-full">
                <mat-label>Product Code </mat-label>
                <input
                  type="text"
                  formControlName="product_code"
                  matInput
                  [readonly]="true"
                  [errorStateMatcher]="matcher"
                />
              </mat-form-field>
              <mat-form-field class="tablet-max:w-full">
                <mat-label>Month</mat-label>
                <mat-select formControlName="month">
                  @for(month of basisMonths; track month.label){
                  <mat-option [value]="month.value" class="text-sm"
                    >{{ month.label }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label class="tablet-max:w-full">Year</mat-label>
                <mat-select formControlName="year">
                  @for(year of basisYears; track year){
                  <mat-option [value]="year">{{ year }} </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if ( newLotForm.hasError('priceRequired') &&
            (newLotForm.get('basisPriceControl').touched ||
            newLotForm.get('basisPriceControl').dirty) ) {
            <mat-error class="text-sm"
              >Please enter a number greater than 0
            </mat-error>
            } @if ( newLotForm .get('basisPriceControl') .get('basisPoints')
            .hasError('pattern') &&
            newLotForm.get('basisPriceControl').get('basisPoints').dirty &&
            newLotForm.get('priceTypeControl').value === 'Basis' ) {
            <mat-error class="text-sm"
              >Price should not exceed 4 decimal places
            </mat-error>
            }
          </div>
          }
          <div
            class="w-full flex flex-row gap-2 justify-stretch items-stretch mb-4"
          >
            @if (newLotForm.get('priceTypeControl').value === 'Basis') {
            <mat-form-field class="w-8/12" formGroupName="basisPriceControl">
              <mat-label>Basis Quote</mat-label>
              <input
                [readonly]="true"
                type="text"
                matInput
                [value]="basisQuote()"
                [errorStateMatcher]="matcher"
              />
            </mat-form-field>
            } @if (newLotForm.get('priceTypeControl').value === 'Cash') {
            <mat-form-field class="w-8/12">
              <mat-label>Price</mat-label>
              <span matPrefix>&nbsp; {{ currencyPrefix }} &nbsp;</span>
              <input
                type="number"
                matInput
                [formControl]="newLotForm.get('priceControl')"
                [errorStateMatcher]="matcher"
                placeholder="Enter a number"
              />
              @if ( newLotForm.hasError('priceRequired') &&
              newLotForm.get('priceControl').touched &&
              newLotForm.get('priceTypeControl').value === 'Cash' ) {
              <mat-error class="text-sm"
                >Please enter a number greater than 0
              </mat-error>
              } @if(newLotForm.get('priceControl').hasError('pattern') &&
              (newLotForm.get('priceControl').touched ||
              newLotForm.get('priceControl').dirty ) &&
              newLotForm.get('priceTypeControl').value === 'Cash' ){
              <mat-error class="text-sm">
                Can only allow postive numbers up to 4 decimal places
              </mat-error>
              }
            </mat-form-field>
            } @if (priceUnits$ | async; as priceUnits) {
            <mat-form-field class="w-2/5">
              <mat-label>Price Units</mat-label>
              <mat-select [formControl]="newLotForm.get('priceUnitsControl')">
                @for (unit of priceUnits; track unit.name) {
                <mat-option [value]="unit.name">{{ unit.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            }
          </div>
        </div>
        <mat-form-field class="w-full">
          <mat-label>Quantity (MT)</mat-label>
          <input
            type="number"
            matInput
            [formControl]="newLotForm.get('quantityControl')"
            [errorStateMatcher]="matcher"
            placeholder="Enter an integer number"
          />
          @if ( newLotForm.get('quantityControl').hasError('pattern') ||
          (newLotForm.get('quantityControl').hasError('required') &&
          (newLotForm.get('quantityControl').touched ||
          newLotForm.get('quantityControl').dirty)) ) {
          <mat-error>Please enter an integer number greater than 0</mat-error>
          }
        </mat-form-field>
      </mat-card>
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Payment Terms</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-7 mb-6 mx-auto max-w-xl flex flex-col"
      >
        <app-autocomplete
          label="Governing Rule"
          [autocompleteControl]="newLotForm.get('governingRule')"
          [required]="true"
          [options]="rulesToGovern$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <app-autocomplete
          label="Weight/Grade To Govern"
          [autocompleteControl]="newLotForm.get('weightGradeToGovernControl')"
          [required]="true"
          [options]="weightGradeToGovern$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
        <app-autocomplete
          label="Payment Terms"
          [autocompleteControl]="newLotForm.get('paymentTermControl')"
          [required]="true"
          [options]="paymentTerms$ | async"
          [errorStateMatcher]="matcher"
        ></app-autocomplete>
      </mat-card>
      <div class="flex items-center mx-auto max-w-xl pl-2.5 mb-2">
        <div class="text-md dark:text-gray-300">Additional Notes or Terms</div>
      </div>
      <mat-card
        appearance="outlined"
        class="rounded-md tablet-max:rounded-xl py-5 px-6 mb-6 mx-auto max-w-xl flex flex-col"
      >
        <mat-form-field class="example-full-width">
          <mat-label>Leave a comment</mat-label>
          <textarea
            matInput
            [formControl]="newLotForm.get('additionalNoteControl')"
            [errorStateMatcher]="matcher"
          ></textarea>
        </mat-form-field>
      </mat-card>
      <!-- Buttons at the end of the form -->
    </form>
  </div>
  <div class="sticky bottom-4 left-0 right-0 flex justify-center mt-4">
    <button
      (click)="onSubmit()"
      type="submit"
      [style.opacity]="buttonOpacity"
      class="bg-custom-orange button-transition text-white text-md p-4 rounded-full flex items-center justify-center w-40 ml-2"
    >
      Create
    </button>
  </div>
</div>
}
